import { Link } from 'react-router';
import { formatShortDate, formatThousands } from '../../../../Utils/dates/formatDate';
import { cssToPacePer100 } from '../../../../Utils/format/pace';
import { initials, sinceText } from './athleteActivityModel';
import styles from './AthleteActivityCard.module.css';

const AthleteActivityRow = ({ row, now }) => {
    const last = row.lastWorkout;
    const pace = cssToPacePer100(row.currentCSS);
    return (
        <li>
            <Link to={`/athlete/${row.id}/dashboard`} className={styles.row}>
                <div className={styles.who}>
                    <span className={styles.avatar} aria-hidden="true">
                        {initials(row)}
                    </span>
                    <div style={{ minWidth: 0 }}>
                        <b>
                            {row.firstName} {row.lastName}
                        </b>
                        <small>{row.email}</small>
                    </div>
                </div>
                {last ? (
                    <div className={styles.last}>
                        {formatShortDate(last.workoutStart)}
                        <small>
                            {[sinceText(row, now), last.volume != null && `${formatThousands(last.volume)} m`]
                                .filter(Boolean)
                                .join(' · ')}
                        </small>
                    </div>
                ) : (
                    <div className={styles.last}>
                        <span className={styles.none}>{sinceText(row, now)}</span>
                    </div>
                )}
                <div className={styles.css}>
                    {row.currentCSS ? pace : <small>not set</small>}
                </div>
            </Link>
        </li>
    );
};

export default AthleteActivityRow;
